import { render, staticRenderFns } from "./IncidentsStatusesConfigurations.vue?vue&type=template&id=d377229c&scoped=true"
import script from "./IncidentsStatusesConfigurations.vue?vue&type=script&lang=js"
export * from "./IncidentsStatusesConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d377229c",
  null
  
)

export default component.exports